/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { IFair } from '@umati/dashboard-types';
import URLs from '../utilities/URLs';

const SetFullFairImageURLs = (fair: IFair) => {
  fair.ImageFile = URLs.getFullFairLogoUrl(fair.ImageFile);
  return fair;
};

const arrayToObject = (arr: IFair[], key1: keyof IFair) => {
  return Object.assign({}, ...(arr.map(item => {
    return { [item[key1]! as string]: SetFullFairImageURLs(item) };
  })));
};

export class FairHandling {
  static deserializeFairsFromBackendRequest (data: IFair[]) {
    return arrayToObject(data, 'Tag');
  }
}
